import { useEffect, useRef } from "react";
import { ThemeProvider } from "styled-components";
import UnifyRoute from "./UnifyRoute";
import { useUserProfileData } from "./useUserProfileQueries";
import {useGlobalStore} from "./GlobalStore";
import { LoginEventListener } from "./LoginEventListener";
import { CNumberListener } from "./CNumberListener";
import * as Styles from "./styles";
import { useTheme } from "../theme/useTheme";
import CSPContainer from "./CSPContainer";
import { darkMode as RDSDarkMode, theme as RDSLightMode ,CustomScrollbarWrapper} from "cdk-radial";
import userProfileStore from "./UserProfileStore";
import {useUserIPRestriction} from '../dealer-admin/useDealerAdminQueries';
import {useGetApplication} from '../home/useApplicationQueries';
import Header from "../header/Header";
import { useCampaign } from "../campaign/useCampaign";
import SideSheetContainer from "../components/SideSheet/SideSheetContainer";
import ToastContainer from "../components/Toast/ToastContainer";
import { NotificationContainer } from "../notification/NotificationContainer";
import WebViewManager from "../webview/WebViewManager";
import CustomWebViewManager from "../webview/CustomWebViewManager";
import Navigation from "../navigation/Navigation";
import {useGetCNumbers,useFetchDMSBoxMapping} from "../drive/userDriveQueries";
import  Walkme from '../third-party-integration/walkme/Walkme';
import { useHelpStore } from '../help/HelpStore';
import {SSENotification} from '../sse/NotificationReciever';
import { AppLoader } from "../common/AppLoader";
import Qualtrics from '../third-party-integration/qualtrics/Qualtrics';
import {ErrorBoundary} from './ErrorBoundary';
import { useIPRestrictionStore } from '../dealer-admin/ip-access/IPRestrictionStore';
import UnifyRestrictionDialog from './UnifyRestrictionDialog';
import {  useOktaAuth } from "@okta/okta-react";
import {
    AMPLITUDE_EVENTS,LOGOUT_URL, OKTA_LOGOUT_URL
} from '../../constants';
import {useAnalytics, markStartupTracked} from '../third-party-integration/amplitude';
import useAudit from '../../hooks/useAudit';
import getUserIdFromOkta from '../../util/getUserIdFromOkta';
import Aha from '../third-party-integration/aha/Aha';
import NewRelic from '../third-party-integration/newrelic/NewRelic';
import GetMobileAppDialog from '../home/GetMobileAppDialog';
import styled from 'styled-components';
import AivaWrapper from "../third-party-integration/aiva/AivaWrapper";
import ChannelMessageProvider from "../channel-message/ChannelMessagingProvider";
import {useGetUserSetting} from '../dashboard/useDashboardQueries';
//import {useSmartVersionCheck} from "../core/VersionCheck";
//import NewReleaseDialog from "../common/NewReleaseDialog";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import { useFeatureFlagWithFailsafe } from "../../hooks/useFeatureFlagWithFailsafe";
import StartupAppRedirect from '../startup-app/StartupAppRedirect';
import AdoptEaseContainer from "../adopt-ease/AdoptEaseContainer";
import { useAdoptEaseCampaigns } from "../adopt-ease/useAdoptEase";
import StartupDriveLauncher from "../startup-app/StartupDriveLauncher";
import { useApplicationStore } from "../home/ApplicationStore";
import AmplitudeRCContainer from '../third-party-integration/amplitude/AmplitudeRCContainer';
import { clearLocalStorageExceptDMS } from "../../util/clearLocalStorage";

// If $identify can't run (profile/applications never load), still boot Guides & Surveys and
// track the startup events after this long.
const STARTUP_ANALYTICS_FALLBACK_MS = 10000;


const loadDynamicWalkmeScript = (walkmeScript: string) => {
    let script: any = document.querySelector(`script[src="${walkmeScript}"]`);
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/javascript');
      script.setAttribute('src', walkmeScript);
      script.setAttribute('class', 'walkme-to-remove');
      script.async = true;
      script.defer = false;
      script.onload = () => {
        script.dataset.loaded = 'true';
      };
      document.head.appendChild(script);
      window._walkmeConfig = { smartLoad: true };
    }
};

export const StyledCustomScrollbarWrapper = styled(CustomScrollbarWrapper)`
  height: calc(100vh - 48px);
  overflow: auto;
`;


export const StyledMainWrapper = styled.div`
  border: 1px solid rgb(0, 0, 0);
  flex:1;
  min-width: 0;
  border-top-left-radius: 4px;
`;



const UnifyContainer = (() => {

  /*useSmartVersionCheck({
      periodicCheckInterval: 30 * 60 * 1000, // 30 minutes
      checkOnVisibility: true,
      checkOnFocus: false,
      onUpdateAvailable: (version) => {
        //setIsOpen(true);
        //console.log('Update available:', version);
        //console.log("new version of app is released ")
        // Optional: Send analytics event
        // trackEvent('update_available', { version });
      },
    });*/
 
  const { oktaAuth } = useOktaAuth();
  const { trackEvent, identify, setUserId, bootEngagement, setTheme, setLanguage } = useAnalytics();
  const { captureEvent } = useAudit();
  const enableIdpProxyFlag = useFeatureFlagWithFailsafe('UNIFY_ENABLE_IDP_PROXY');
  const isAmplitudeEnabled = useFeatureFlag('UNIFY_UI_AMPLITUDE');
  const adoptEaseApplicationFlag = useFeatureFlag('UNIFY_UI_ADOPTEASE_APPLICATION');
  const adoptEaseDriveFlag = useFeatureFlag('UNIFY_UI_ADOPTEASE');
  const adoptEaseJournalEntryFlag = useFeatureFlag('UNIFY_UI_ADOPTEASE_JOURNALE');
  const adoptEaseCustomerFlag = useFeatureFlag('UNIFY_UI_ADOPTEASE_CUSTOMER');
  const adoptEaseVendorFlag = useFeatureFlag('UNIFY_UI_ADOPTEASE_VENDOR');
  const adoptEaseFlag = adoptEaseApplicationFlag || adoptEaseDriveFlag || adoptEaseJournalEntryFlag || adoptEaseCustomerFlag || adoptEaseVendorFlag;

  const { applications, workflows } = useApplicationStore();
  const { isFetching } = useUserProfileData(enableIdpProxyFlag);
  const {isLoading: isUserIPRestrictionLoading,  } = useUserIPRestriction();
  const {isMutating,isLoggingOut,isNavBarCollapsed,logoutMessage,isSSEConnected} = useGlobalStore() ;
  const { locale,enterpriseId, email,currentStoreId,currentStore,iamUserProfile} = userProfileStore();
  
  const {application} = useGetApplication(locale,enterpriseId);
  const { walkmeScript ,setWalkmeLoaded } = useHelpStore((state: any) => state);
  const {data:cnumberData} = useGetCNumbers();
  const {isUnifyRestricted, unifyRestrictedMessage} = useIPRestrictionStore();
  useFetchDMSBoxMapping();

  const { darkMode } = useTheme();
  const theme = darkMode ? RDSDarkMode : RDSLightMode;
  useCampaign();
  useAdoptEaseCampaigns();
  const {isLoading: isUserSettingLoading  } =useGetUserSetting(enterpriseId, currentStoreId);

  // Startup analytics run once, in order: $identify -> Engagement Booted -> Log in Unify.
  // identify waits for the profile and applications to load; if that never happens (e.g. the
  // profile request fails), the fallback still boots and tracks.
  const startupTrackedRef = useRef(false);
  const startupFallbackRef = useRef<ReturnType<typeof setTimeout>>();

  const trackStartup = async () => {
    if (startupTrackedRef.current) return;
    startupTrackedRef.current = true;
    clearTimeout(startupFallbackRef.current);
    try {
      await bootEngagement();
      // Theme/language calls made before boot were no-ops (window.engagement didn't exist yet).
      if (locale) setLanguage(locale);
      if (darkMode) setTheme('dark');
    } catch (err) { }
    trackEvent(AMPLITUDE_EVENTS.LOGIN_UNIFY);
    trackEvent(AMPLITUDE_EVENTS.VIEW_UNIFY_2_PAGE);
    trackEvent(AMPLITUDE_EVENTS.SCREEN_RESOLUTION, { 'Height': window.innerHeight, 'Width': window.innerWidth, 'Resolution': `${window.innerWidth}x${window.innerHeight}` });
    markStartupTracked();
  };

  useEffect(() => {
    try {
      const userId = getUserIdFromOkta();
      if (userId) {
        setUserId(userId);
      }
    } catch (err) { }
    startupFallbackRef.current = setTimeout(trackStartup, STARTUP_ANALYTICS_FALLBACK_MS);
    return () => clearTimeout(startupFallbackRef.current);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    try {
      const userId = getUserIdFromOkta();
      if (userId && enterpriseId && applications && applications.length > 0 ) {
        const defaultStore = currentStore?.[0];
        const enterpriseName = iamUserProfile?.fullUser ? ` ${iamUserProfile?.fullUser?.enterprise?.name}` : ``;
        const userRoles = (iamUserProfile?.fullUser?.roles || []).map((role: any) => role.roleName);
        if(isAmplitudeEnabled){
        identify({
          'user_id': userId,
          'user_role': userRoles,
          'enterprise_id': enterpriseId,
          'enterprise_name': enterpriseName,
          'store_id': defaultStore?.id,
          'store_name': defaultStore?.name,
          'stores': iamUserProfile?.fullUser?.stores?.map(({ id, name }: any) => `${id} ${name}`),
          'applications':applications?.map((app: any) => app.name),
          'workflows': workflows?.map((workflow: any) => workflow.name)
        });
        trackStartup();
        }else{
          identify({
            'User ID': userId,
            'Enterprise ID': enterpriseId,
            'User role': userRoles,
            'Stores': iamUserProfile?.fullUser?.stores?.map(({ id, name }: any) => `${id} ${name}`),
            'Store Id': defaultStore?.id,
            'Enterprise Name': enterpriseId + enterpriseName,
            'Store Name': defaultStore?.id + ` ${defaultStore?.name}`,
          });
          trackStartup();
        }
      }
    } catch (err) { }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iamUserProfile, enterpriseId,applications,isAmplitudeEnabled]);


  useEffect(() => {
    try {
      if (locale) {
        setLanguage(locale);
      }
    } catch (err) { }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

    useEffect(() => {
    try {
      if (darkMode ) {
        setTheme(darkMode ? 'dark' : 'light');
      }
    } catch (err) { }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [darkMode]);


    useEffect(() => {
      let timeoutId: any;
  
      const handleResize = () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          trackEvent(AMPLITUDE_EVENTS.SCREEN_RESIZED, { 'Height': window.innerHeight, 'Width': window.innerWidth, 'Resolution': `${window.innerWidth}x${window.innerHeight}` });
        }, 300);
      };
  
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
        clearTimeout(timeoutId);
      }
      // eslint-disable-next-line
    }, []);

    const unifyAppRestrictedLogout = async () => {
    trackEvent(AMPLITUDE_EVENTS.LOGOUT_UNIFY,{'Action': 'Unify App Restricted Logout'});
    captureEvent({action: "Unify App Restricted Logout"});
    const idToken = oktaAuth.getIdToken();

    if (!idToken) {
      await oktaAuth.tokenManager.clear();
      clearLocalStorageExceptDMS();
      window.location.assign(`${LOGOUT_URL}?source=unify`);
      return;
    }

    if (enableIdpProxyFlag) {
      const unifyLogoutCallbackUrl = window.location.origin + '/logout/callback';
      const oktaDomainLogoutPath = `${OKTA_LOGOUT_URL}?id_token_hint=${encodeURIComponent(String(idToken))}&post_logout_redirect_uri=${encodeURIComponent(unifyLogoutCallbackUrl)}`;
      window.location.assign(oktaDomainLogoutPath);
      return;
    }

    await oktaAuth.tokenManager.clear();
    clearLocalStorageExceptDMS();
    await oktaAuth.signOut({
      postLogoutRedirectUri: `${LOGOUT_URL}?source=unify&id_token_hint=${encodeURIComponent(String(idToken))}`
    });
  };

  const NAV_W = isNavBarCollapsed ? 14 : 74; 

  useEffect(() => {
    window.WalkMeLoginId = email;
    loadDynamicWalkmeScript(walkmeScript)
    window.walkme_ready = function () {
      setWalkmeLoaded(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email,setWalkmeLoaded]);

  //const handleContinue = () =>{
     // window.location.href = `${window.location.origin}${window.location.pathname}?v=${Date.now()}`;
  //}

  return (
          <Styles.UnifyContainer>
            <CSPContainer/>
            <ThemeProvider theme={theme}>
            <ChannelMessageProvider>
              <AmplitudeRCContainer/>
              <Styles.Backplane id="backplane">

                {/*<NewReleaseDialog isOpen={false} onClose={()=> setIsOpen(false)} onContinue={handleContinue} ></NewReleaseDialog>*/}
                {(isLoggingOut) && <AppLoader loaderText={logoutMessage} />}

                {(isFetching || 
                  isMutating ||
                  isUserIPRestrictionLoading ||
                  isUserSettingLoading ||
                  application.isFetching) && (!isLoggingOut)
                    && <AppLoader loaderText={"CDK Unify"} />}

                  { !isLoggingOut && isUnifyRestricted && 
                    <UnifyRestrictionDialog
                          message={unifyRestrictedMessage}
                          isOpen={isUnifyRestricted}
                          onClose={unifyAppRestrictedLogout}/>
                  }

              {(!isFetching &&
                !application.isFetching &&
                !isUserIPRestrictionLoading &&
                !isUserSettingLoading &&
                !isUnifyRestricted ) && (
                  <>
                  { (isSSEConnected && adoptEaseFlag ) && <AdoptEaseContainer/> }
                  <StartupAppRedirect />
                  <StartupDriveLauncher />
                  <div style={{width:"100%"}}>
                    <Header />
                  </div>
                  <div style={{display:"flex", flexDirection:"row",background:"black" }}> 
                    <Styles.SideNavContainer navWidth={NAV_W}>
                    <Navigation/>
                    </Styles.SideNavContainer>
                      <StyledMainWrapper>
                        <StyledCustomScrollbarWrapper id="custom-scrollbar-wrapper" >
                          <SSENotification></SSENotification>
                          <LoginEventListener></LoginEventListener>
                          { cnumberData && <CNumberListener></CNumberListener> }
                          <NotificationContainer></NotificationContainer>
                          <WebViewManager />
                            <ErrorBoundary >
                              <AivaWrapper />
                            </ErrorBoundary>
                          <CustomWebViewManager/>
                          <ErrorBoundary
                            fallback={() => (
                              <div style={{ padding: 16, textAlign: 'center' }}>
                                <h3>Loading Failed — A New Version Is Available</h3>
                                <p style={{ marginBottom: 16 }}>The page failed to load. Please refresh to get the latest version.</p>
                                <button
                                  onClick={() => window.location.reload()}
                                  style={{
                                    backgroundColor: '#0066cc',
                                    color: 'white',
                                    border: 'none',
                                    padding: '8px 20px',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  Refresh Now
                                </button>
                              </div>
                            )}
                          >
                            <UnifyRoute></UnifyRoute>
                          </ErrorBoundary>
                        </StyledCustomScrollbarWrapper>
                      </StyledMainWrapper>
                      <SideSheetContainer></SideSheetContainer>
                      <ToastContainer></ToastContainer>
                      <GetMobileAppDialog></GetMobileAppDialog>
                      <Aha></Aha>
                      </div>
                      </>
                      )}
            </Styles.Backplane>
          <div id="walkme-pane" data-testid="walkme-pane" ><Walkme></Walkme></div>
        <Qualtrics></Qualtrics>
        <NewRelic></NewRelic>
        </ChannelMessageProvider>
      </ThemeProvider>
    </Styles.UnifyContainer>
  );
});

export default UnifyContainer;